(function () {
  'use strict';

  var root = document.getElementById('collection-slider-root');
  if (!root) return;

  var pageHandle = root.dataset.collection;
  var dataUrl    = root.dataset.dataUrl;

  var data;
  var stripParent = null;
  var pageTitle = '';
  var heroTitleEl = document.querySelector('.collection-hero__title motion-element');
  var heroDescEl  = document.querySelector('.collection-hero__description');

  fetch(dataUrl)
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(init)
    .catch(function (err) {
      console.info('[CollectionSlider] Data not available:', err.message);
      root.remove();
    });

  function init(d) {
    data = d;
    pageTitle = titleOf(pageHandle);

    // The slider only appears on categories that have subcategories. Leaf
    // categories (no children) show just their product grid.
    var kids = (d.c[pageHandle] || []).filter(function (h) { return d.n[h]; });
    if (!kids.length) {
      root.remove();
      return;
    }

    var wrapper = document.getElementById('ProductGridWrapper');
    if (wrapper) wrapper.insertBefore(root, wrapper.firstChild);
    render(pageHandle, null);
    root.hidden = false;

    // A parent page's own collection may hold few or none of its descendants'
    // products. Once the filter index is ready, show the union of everything
    // beneath it — unless the native grid already contains all of them, in which
    // case keep Shopify's server-rendered grid and numbered pagination.
    var empty = document.querySelector('#ProductGridContainer .empty-state');
    if (empty) empty.style.display = 'none';
    whenFiltersReady(function (mff) {
      var all = mff.productsFor(pageHandle, data.c);
      if (all.length > mff.nativeTotal()) mff.showProducts(all);
      else if (empty) empty.style.display = '';
    });

    window.addEventListener('popstate', function () { window.location.reload(); });
  }

  function whenFiltersReady(cb) {
    var mff = window.MetafieldFilters;
    if (mff && mff.ready) return cb(mff);
    document.addEventListener('mff:ready', function () { cb(window.MetafieldFilters); }, { once: true });
  }

  // ── Rendering ────────────────────────────────────────────────────────────────
  function render(parent, selected) {
    stripParent = parent;
    var kids = (data.c[parent] || []).filter(function (h) { return data.n[h]; });

    var html =
      '<div class="cs-strip" role="navigation" aria-label="Subcategories">' +
        '<button type="button" class="cs-arrow cs-arrow--prev" aria-label="Scroll left" hidden>&#8249;</button>' +
        '<div class="cs-track">' +
          '<a class="cs-pill cs-pill--all' + (selected ? '' : ' is-active') + '" href="/collections/' + esc(parent) +
            '" data-handle="' + esc(parent) + '" data-all="1"><span>All</span></a>';

    kids.forEach(function (h) {
      var img = imgUrl(data.n[h][1]);
      html +=
        '<a class="cs-pill' + (h === selected ? ' is-active' : '') + '" href="/collections/' + esc(h) +
          '" data-handle="' + esc(h) + '">' +
          '<span class="cs-pill__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="cs-pill__label">' + esc(data.n[h][0]) + '</span>' +
        '</a>';
    });

    html +=
        '</div>' +
        '<button type="button" class="cs-arrow cs-arrow--next" aria-label="Scroll right" hidden>&#8250;</button>' +
      '</div>';

    root.innerHTML = html;
    bindStrip();

    var active = root.querySelector('.cs-pill.is-active:not(.cs-pill--all)');
    var track  = root.querySelector('.cs-track');
    if (active && track) track.scrollLeft = Math.max(0, active.offsetLeft - track.offsetLeft - 8);
    updateArrows();
  }

  function bindStrip() {
    var track = root.querySelector('.cs-track');
    var prev  = root.querySelector('.cs-arrow--prev');
    var next  = root.querySelector('.cs-arrow--next');

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  track.clientWidth * 0.8, behavior: 'smooth' }); });

    track.addEventListener('click', function (e) {
      var pill = e.target.closest('.cs-pill');
      if (!pill) return;
      var mff = window.MetafieldFilters;
      // Filter index not loaded (or unavailable) — let the link navigate normally.
      if (!mff || !mff.ready) return;
      e.preventDefault();
      select(pill.dataset.handle, pill.dataset.all === '1', mff);
    });
  }

  function updateArrows() {
    var track = root.querySelector('.cs-track');
    var prev  = root.querySelector('.cs-arrow--prev');
    var next  = root.querySelector('.cs-arrow--next');
    if (!track || !prev || !next) return;
    prev.hidden = track.scrollLeft <= 4;
    next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }

  // ── Selection ────────────────────────────────────────────────────────────────
  function select(handle, isAll, mff) {
    var viewHandle = handle;
    var hasKids = !isAll && data.c[handle] && data.c[handle].length;

    mff.showProducts(mff.productsFor(viewHandle, data.c));

    if (hasKids) {
      // Drilling into a category that has its own subcategories: the strip now
      // lists those, with "All" selected.
      render(handle, null);
    } else {
      var pills = root.querySelectorAll('.cs-pill');
      for (var i = 0; i < pills.length; i++) {
        var on = isAll ? pills[i].dataset.all === '1' : pills[i].dataset.handle === handle && pills[i].dataset.all !== '1';
        pills[i].classList.toggle('is-active', on);
      }
    }

    var title = titleOf(viewHandle);
    if (heroTitleEl) heroTitleEl.textContent = title;
    if (heroDescEl) heroDescEl.style.display = viewHandle === pageHandle ? '' : 'none';
    document.title = document.title.replace(pageTitle, title);
    pageTitle = title;

    try { history.pushState({ cs: 1 }, '', '/collections/' + viewHandle); } catch (e) { /* ignore */ }
  }

  // ── Helpers ──────────────────────────────────────────────────────────────────
  function titleOf(handle) {
    return data.n[handle] ? data.n[handle][0] : handle;
  }

  function imgUrl(src) {
    if (!src) return '';
    return src.replace(/(\.[a-z0-9]+)(\?|$)/i, '_240x$1$2');
  }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
})();
